import script from "./CoreUiAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiAvatar.vue?vue&type=style&index=0&id=d32311ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d32311ea"]])

export default __exports__